var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellicon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 50,
    viewBox: "0 0 38 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 50.0001C16.4227 50.0001 14.3333 47.7615 14.3333 45.0001H23.6666C23.6666 47.7615 21.5773 50.0001 19 50.0001ZM37.6666 42.5001H0.333313V37.5001L4.99998 35.0001V21.2501C4.87705 17.7229 5.6205 14.2229 7.15598 11.1001C8.6844 8.20386 11.2969 6.14728 14.3333 5.45008V8.13288e-05H22.8406C19.8082 3.63116 19.3021 8.94107 21.5869 13.1539C23.8717 17.3668 28.4281 19.5249 32.874 18.5001C32.9557 19.3926 32.9953 20.3176 32.9953 21.2501V35.0001L37.662 37.5001V42.5001H37.6666ZM30.6666 15.0001C26.956 14.9939 23.8945 11.8865 23.6883 7.91689C23.4821 3.94732 26.2028 0.495048 29.8899 0.0477162C33.577 -0.399616 36.9493 2.31344 37.5767 6.2319C38.2042 10.1504 35.8687 13.9126 32.2533 14.8076C31.7329 14.9357 31.2006 15.0002 30.6666 15.0001Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellicon);
export default __webpack_public_path__ + "static/media/bellicon.94504433c9a441e3d5aa3788632807b3.svg";
export { ForwardRef as ReactComponent };